export class NoTokenError extends Error {
  constructor(...args) {
    super(...args);
    this.name = "NoTokenError";
    this.constructor = NoTokenError; 
    this.__proto__   = NoTokenError.prototype
  }
}

export class AuthorizationError extends Error {
  constructor(route) {
    super();
    this.message = `Permission Denied on route: ${route}`;
    this.name = "AuthorizationError";
    this.constructor = AuthorizationError; 
    this.__proto__   = AuthorizationError.prototype
  }
}
